import { useState } from "react";

export const useToggle = (
  initalState = false,
): {
  value: boolean;
  toggle: () => void;
  forceTrue: () => void;
  forceFalse: () => void;
  setState: (val: boolean) => void;
} => {
  const [state, setState] = useState<boolean>(initalState);
  const toggle = () => setState(!state);

  const forceTrue = () => setState(true);
  const forceFalse = () => setState(false);

  return { value: state, toggle, forceTrue, forceFalse, setState };
};
